export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center bg-background-50 overflow-hidden pt-16"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              每日更新 · 高清秒播
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              爱看影院
              <span className="block text-primary-600 mt-1">高清电影电视剧在线观看平台</span>
            </h1>

            <p className="text-foreground-600 text-lg font-medium mb-5 leading-relaxed">
              海量高清影视，不缓冲秒播，追剧从未如此畅快
            </p>

            <div className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              <p>
                爱看影院汇聚10万+高清电影和电视剧资源，覆盖剧情、悬疑、科幻、喜剧、动漫、纪录片等全品类内容。每日同步更新最新热播剧集，采用全球CDN加速与自适应码率技术，确保真高清画质秒开秒播。无论你想追热门大剧、重温经典老片，还是发现冷门佳片，爱看影院都是你的不二之选。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600 font-heading">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600 font-heading">5000万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">追剧零延迟</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-300 hover:bg-primary-50/50 text-foreground-700 font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20interior%20with%20golden%20ambient%20lighting%2C%20elegant%20art%20deco%20inspired%20design%2C%20soft%20velvet%20curtains%20framing%20the%20scene%2C%20film%20reel%20projected%20light%20beam%20creating%20dramatic%20atmosphere%2C%20rich%20amber%20and%20warm%20bronze%20tones%2C%20artistic%20abstract%20interpretation%2C%20luxurious%20and%20inviting%20mood%2C%20high%20detail%20editorial%20style%20photography%20with%20soft%20shadows%20and%20harmonious%20composition&width=800&height=600&seq=hero-main-2026&orientation=landscape"
                alt="爱看影院 - 高清影院观影体验"
                className="w-full h-full object-cover object-top"
                width="800"
                height="600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">
                  4K 超清画质
                </span>
                <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">
                  秒播不缓冲
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}